<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <p class="text">{{ message }}</p>
      <div class="wrapper-buttons">
        <StandardButton
          :buttonLabel="'Cancelar'"
          @click="clickDeny"
          :is-cancel="true"
          class="full"
        />
        <StandardButton
          :buttonLabel="'Aceptar'"
          class="full"
          @click="clickAccept"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalConfirmation",
  components: {
    StandardButton,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    function clickAccept() {
      context.emit("accept");
    }

    function clickDeny() {
      context.emit("deny");
    }

    return {
      clickAccept,
      clickDeny,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/modals/modalConfirmationStyle";
</style>
